/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamAnalysisCorrectionValuesDto } from './BeamAnalysisCorrectionValuesDto';
import {
    instanceOfBeamAnalysisCorrectionValuesDto,
    BeamAnalysisCorrectionValuesDtoFromJSON,
    BeamAnalysisCorrectionValuesDtoFromJSONTyped,
    BeamAnalysisCorrectionValuesDtoToJSON,
} from './BeamAnalysisCorrectionValuesDto';

/**
 * @type BeamAnalysisWorkResultDtoCorrections
 * 
 * @export
 */
export type BeamAnalysisWorkResultDtoCorrections = BeamAnalysisCorrectionValuesDto;


export function BeamAnalysisWorkResultDtoCorrectionsFromJSON(json: any): BeamAnalysisWorkResultDtoCorrections {
    return BeamAnalysisWorkResultDtoCorrectionsFromJSONTyped(json, false);
}

export function BeamAnalysisWorkResultDtoCorrectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkResultDtoCorrections {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...BeamAnalysisCorrectionValuesDtoFromJSONTyped(json, true) };
    return  BeamAnalysisCorrectionValuesDtoFromJSONTyped(json, true);
}

export function BeamAnalysisWorkResultDtoCorrectionsToJSON(value?: BeamAnalysisWorkResultDtoCorrections | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfBeamAnalysisCorrectionValuesDto(value)) {
        return BeamAnalysisCorrectionValuesDtoToJSON(value as BeamAnalysisCorrectionValuesDto);
    }

    return {};
}

/**
 * Check if a given object implements the BeamAnalysisWorkResultDtoCorrections interface.
 */
export function instanceOfBeamAnalysisWorkResultDtoCorrections(value: any): value is BeamAnalysisWorkResultDtoCorrections {
    if (instanceOfBeamAnalysisCorrectionValuesDto(value)) return true;
    return false;
}

